module.exports = __webpack_public_path__ + "static/htjBanner1-91702dc4c3c5c5ff66a6cf1cdce3f99c.png";